import { render, staticRenderFns } from "./MainHeader.vue?vue&type=template&id=673e4cef"
import script from "./MainHeader.vue?vue&type=script&lang=js"
export * from "./MainHeader.vue?vue&type=script&lang=js"
import style0 from "./MainHeader.vue?vue&type=style&index=0&id=673e4cef&prod&lang=scss"
import style1 from "./MainHeader.vue?vue&type=style&index=1&id=673e4cef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports